import { render, staticRenderFns } from "./LoanCalculator.vue?vue&type=template&id=2d4c683d&scoped=true"
import script from "./LoanCalculator.vue?vue&type=script&lang=js"
export * from "./LoanCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4c683d",
  null
  
)

export default component.exports